import styled from 'styled-components';

export const TabContainer = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;

    padding: 0.5rem;
    background: #323846;
    border-radius: 12px;

    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);

    overflow-x: auto;
`;

export const TabItem = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;

    padding: 0.55rem 1rem;
    border-radius: 10px;
    border: none;
    cursor: pointer;

    font-size: 0.9rem;
    font-weight: 500;

    background: ${({ $active }) => ($active ? 'rgba(255, 255, 255, 0.08)' : 'transparent')};

    color: ${({ $active }) => ($active ? '#e5e7eb' : '#9ca3af')};

    transition: background 0.2s ease, color 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.06);
        color: #f9fafb;
    }
`;

export const TabBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    min-width: 1.4rem;
    height: 1.4rem;
    padding: 0 0.4rem;

    font-size: 0.7rem;
    font-weight: 600;

    color: #e5e7eb;
    background: rgba(255, 255, 255, 0.12);
    border-radius: 999px;
`;
